import React, { useState, useEffect } from 'react'
import { AlertProvider } from './ghospital-p-clinic/context/AlertContext';
import { useAuth } from './ghospital-p-clinic/context/AuthContext'
import { Route, Routes } from 'react-router'

import AuthRoutes from './ghospital-p-clinic/routes/AuthRoutes'
import AssociateRoutes from './ghospital-p-clinic/routes/AssociateRoutes';

import LogoutPage from './ghospital-p-clinic/app/auth/pages/LogoutPage';
import Error404Page from './ghospital-p-clinic/app/errorPages/Error404Page';
import Error401Page from './ghospital-p-clinic/app/errorPages/Error401Page';
import { MqttProvider } from './ghospital-p-clinic/context/MqttContext';
import { AppDataProvider } from './ghospital-p-clinic/context/AppDataContext';




function App() {
    const {isLoggedIn,authUser} = useAuth();
    speechSynthesis.getVoices();
    
    
    return (
        <>
        <AlertProvider>
            {isLoggedIn ? 
                <>
                {/* <MqttProvider> */}
                    <AppDataProvider>
                        <AssociateRoutes/>
                        <Routes>
                            {/*Logout */}
                            <Route path="/auth/logout" element={<LogoutPage/>}></Route>
                            <Route path="/404" element={<Error404Page/>}></Route>
                            <Route path="/401" element={<Error401Page/>}></Route>
                        </Routes>
                    </AppDataProvider> 
                {/* </MqttProvider>  */ }
                </>
                :
                <AuthRoutes/>
            }
        </AlertProvider>
        </>
    )
}
export default App